/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrop169 = createReactComponent("crop-16-9", "IconCrop169", [
  [
    "path",
    {
      d: "M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ]
]);

export { IconCrop169 as default };
//# sourceMappingURL=IconCrop169.js.map
